import React, { useEffect, useState } from 'react';

const useFlixMediaConfig = (orderStore) => {


  const [flixMediaConfig, setFlixMediaConfig] = useState({
    distributor: null,
    language: null,
    fallbackLanguage: null,
    ok: false,
  });

  useEffect(() => {
    const getCartConfig = async () => {

      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }

      if (orderStore.getCartConfig.success) {
        const flixConfig = orderStore.getCartConfig.data.data.flix_media;

        console.log('flixConfig', flixConfig)

        const flix = flixConfig || {};

        const distributor = flix?.distributor || null;
        const fallbackLanguage = flix?.fallback_language || null;
        const language = flix?.language || null;

        setFlixMediaConfig({
          distributor,
          language,
          fallbackLanguage,
          ok: distributor && language && fallbackLanguage ? true : false,
        });
      }
    };

    getCartConfig();
  }, []);

  return flixMediaConfig;
};



export default useFlixMediaConfig;
